module.exports = __webpack_public_path__ + "static/media/I1_NORM.58bfe280.png";